module.exports = __webpack_public_path__ + "img/ggplay.ef9ef08d.png";